"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var main_1 = require("../../themes/main");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        column: function (prop) { return ({
            flexShrink: 0,
            position: 'relative',
            display: 'inline-block',
            backgroundColor: '#fff',
            width: 230,
            color: '#323A42',
            paddingBottom: prop.addPaddingBottom ? 150 : 0,
        }); },
        headerCell: {
            position: 'sticky',
            top: 0,
            zIndex: 1,
            padding: "".concat(theme.spacing(1.5), "px ").concat(theme.spacing(1), "px"),
            fontWeight: 700,
            borderRadius: 0,
            borderTopLeftRadius: 5,
            backgroundColor: '#fff',
            borderTop: '1px solid #ECEBEA',
            borderLeft: '1px solid #ECEBEA',
            borderBottom: '1px solid #ECEBEA',
            borderRight: '1px solid #ECEBEA',
        },
        sectionHeader: {
            position: 'relative',
            backgroundColor: "".concat(main_1.materialColors.grey[100]),
            padding: "".concat(theme.spacing(0.75), "px ").concat(theme.spacing(1), "px"),
            fontWeight: 700,
            borderRight: '1px solid #ECEBEA',
            height: 30,
        },
        sectionCell: {
            padding: "".concat(theme.spacing(1.5), "px ").concat(theme.spacing(1), "px"),
            borderBottom: '1px solid #ECEBEA',
            borderRight: '1px solid #ECEBEA',
        },
        columnMoreOptions: {
            position: 'absolute',
            top: '50%',
            right: 5,
            transform: 'translateY(-50%)',
            cursor: 'pointer',
            '& svg': {
                color: '#323A42',
            },
        },
    });
});
